import React from 'react';
import { User, Users, Car, Dog } from 'lucide-react';
import { useI18n } from '@/shared/i18n';

export type ProfileTab = 'INFO' | 'FAMILY' | 'VEHICLES' | 'PETS';

interface ProfileTabsProps {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useI18n();

  const tabs = [
    { id: 'INFO' as ProfileTab, label: t('profile.tab.info'), icon: User },
    { id: 'FAMILY' as ProfileTab, label: t('profile.tab.family'), icon: Users },
    { id: 'VEHICLES' as ProfileTab, label: t('profile.tab.vehicles'), icon: Car },
    { id: 'PETS' as ProfileTab, label: t('profile.tab.pets'), icon: Dog },
  ];

  return (
    <div className="flex border-b border-theme bg-surface px-6 rounded-t-xl shadow-sm overflow-x-auto no-scrollbar mb-0">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex items-center gap-2 px-6 py-4 text-sm font-bold border-b-2 transition-colors whitespace-nowrap ${
            activeTab === tab.id
              ? 'border-primary-600 text-primary-600'
              : 'border-transparent text-theme-secondary hover:text-theme'
          }`}
        >
          <tab.icon size={18} />
          {tab.label}
        </button>
      ))}
    </div>
  );
};
